import { useTranslation } from 'react-i18next'
import { CircularProgress } from '@mui/material'

export const ProcessingDocumentWarning = () => {
  const { t } = useTranslation(['common'])

  return (
    <div className="processing-document-warning-container">
      <CircularProgress
        size={20}
        color="warning"
      />
      <div>{t('processingDocumentWarning')}</div>
    </div>
  )
}
